import { animate, state, style, transition, trigger } from '@angular/animations';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-history-form',
  templateUrl: './histor-form.component.html',
  styles: [
  ]
})
export class HistorFormComponent implements OnInit {

  @Input() formGroup: FormGroup;
  @Input() defualtValue: any;
  @Input() isSubmitted: boolean = false;
  @Input() isMultiScope: boolean = false;
  @Input() arrayKey: string = 'data';
  @Output() outputData = new EventEmitter<any>();

  activeIndex: number = 0;
  historySubmitted: boolean = false;

  constructor(private formBuilder: FormBuilder,
    public datepipe: DatePipe
  ) {

  }

  ngOnInit(): void {
    this.formGroup.addControl('deleted_history_scopes', this.formBuilder.control([]));
    if (this.defualtValue && this.defualtValue.length) {
      this.buildForm();
      this.activeIndex = -1;
    } else {
      this.onAddMainScope();
    }
  }

  buildForm() {
    this.defualtValue.forEach(MainScope => {
      this.onAddMainScope(MainScope);
    });
  }

  // Main Scope Controls [START]
  get MainScopes(): FormArray {
    return this.formGroup.get(this.arrayKey) as FormArray;
  }

  public onAddMainScope(defualtValue?: any): void {
    if (!defualtValue) {
      this.MainScopes.updateValueAndValidity();
      this.MainScopes.markAllAsTouched();
    }
    let newMainScopeForm = this.formBuilder.group({
      history_id: [defualtValue ? defualtValue.history_id : 0],
      history_scope_name: [defualtValue ? defualtValue.history_scope_name : (!this.isMultiScope ? "History" : null), Validators.required],
      history: this.formBuilder.array([], Validators.required),
      submitted: [false]
    })

    if (defualtValue?.history?.length) {
      defualtValue.history.forEach(record => {
        (newMainScopeForm.get('history') as FormArray).push(this.historyRecordForm(record))
      });
    }
    this.MainScopes.push(newMainScopeForm);
    if (!defualtValue) {
      this.onAddHistoryRecord(this.MainScopes.length - 1)
    }

  }

  onDeleteMainScope(index: number) {
    if (this.MainScopes.length) {
      const deletedHistoryScopesControl = this.formGroup.get("deleted_history_scopes");
      if (this.MainScopes.value[index].history_id > 0) {
        const arr = [...deletedHistoryScopesControl.value, this.MainScopes.value[index].history_id];
        deletedHistoryScopesControl.setValue(arr);
      }

      this.MainScopes.removeAt(index);

    }
  }

  // Main Scope Controls [END]

  // History Records Controls [START]

  HistoryRecords(mainScopeIndex: number): FormArray {
    return this.MainScopes.controls[mainScopeIndex].get("history") as FormArray;
  }

  onAddHistoryRecord(mainScopeIndex: number, defualtValue?: any) {
    if (!defualtValue) {
      this.HistoryRecords(mainScopeIndex).updateValueAndValidity();
      this.HistoryRecords(mainScopeIndex).markAllAsTouched();
    }
    console.log(this.HistoryRecords(mainScopeIndex));

    this.HistoryRecords(mainScopeIndex).push(this.historyRecordForm(defualtValue));

  }

  historyRecordForm(defualtValue: any) {
    return this.formBuilder.group({
      id: [defualtValue ? defualtValue.id : 0],
      issue_no: [defualtValue ? defualtValue.issue_no : null, Validators.required],
      note: [defualtValue ? defualtValue.note : null, Validators.required],
      date: [defualtValue ? defualtValue.date : null, Validators.required]
    })
  }

  onDeleteHistoryRecord(mainScopeIndex: number, recordIndex: number) {
    if (this.HistoryRecords(mainScopeIndex).length) {
      this.HistoryRecords(mainScopeIndex).removeAt(recordIndex);

    }
  }

  // History Records Controls [End]


  toggleProcedure(index) {
    if (this.activeIndex === index && this.MainScopes.controls[index].valid) {
      this.activeIndex = undefined;
    } else {
      this.activeIndex = index;
    }
  }

  submitMainScope(index: number) {
    this.MainScopes.controls[index].get("submitted").setValue(true);
    this.MainScopes.controls[index].updateValueAndValidity();
    this.MainScopes.controls[index].markAllAsTouched();
    if (this.MainScopes.controls[index].valid) {
      this.toggleProcedure(index);

    }
  }

}


export function FormatedHistoryData(MainScopes: FormArray) {
  const datepipe = new DatePipe('en-US');
  return MainScopes.controls.map((group: FormGroup) => ({
    history_id: group.value?.history_id ? group.value?.history_id : 0,
    history_scope_name: group.value?.history_scope_name,
    history: (group.get('history') as FormArray)?.controls?.map((h: FormGroup) => ({
      ...h.value,
      date: h.value.date ? datepipe.transform(h.value.date, 'yyyy-MM-dd') : null
    })) || []
  }))
}